import {
  US_INVOICE_HISTORICAL,
  US_INVOICE_LINK,
  ERROR_GET_US_INVOICE_POS,
  US_INVOICE_POS,
  REQUEST_US_INVOICE_POS,
} from '../actions/actions_us_invoicing';

const initialState = {
  isSearching: false,
  ordersToInvoice: [],
  error: null,
  generatedUSInvoiceLink: null,
  usInvoiceHistoricalData: {
    orders: [],
    pagination: {},
    pageCount: 0,
  },
};

const usInvoicing = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_US_INVOICE_POS: {
      return {
        ...state,
        isSearching: true,
        ordersToInvoice: [],
      };
    }
    case US_INVOICE_POS: {
      return {
        ...state,
        isSearching: false,
        ordersToInvoice: action.usInvoiceOrders,
      };
    }

    case US_INVOICE_LINK: {
      return {
        ...state,
        generatedUSInvoiceLink: action.generatedUSInvoiceLink,
      };
    }

    case US_INVOICE_HISTORICAL: {
      return {
        ...state,
        usInvoiceHistoricalData: {
          orders: action.usInvoiceHistoricalData,
          pagination: action.pagination,
          pageCount: action.pageCount,
        },
      };
    }

    case ERROR_GET_US_INVOICE_POS: {
      return {
        ...state,
        error: action.error,
        isSearching: false,
      };
    }

    default:
      return state;
  }
};

export default usInvoicing;